module.exports = __webpack_public_path__ + "static/media/TypeReception.6332c4f2.svg";